import { ConnectorTypes } from '../Consts';
import logo from '../../../../images/cc/azure_active_directory_logo.png';
import azureIcon from '../../../../images/cc/azure-24x24.png';
import RulesTab from '../active_directory/Rules';
import GeneralTab from './General';
import AuthTab from './Auth';
import UsersGroupsTab from './UsersGroups';

export default {
    identifier: ConnectorTypes.AZURE_ACTIVE_DIRECTORY,
    name: 'Azure Active Directory Connector',
    shortName: 'Azure',
    icon: azureIcon,
    box: {
        logo,
        title: 'Microsoft Azure Active Directory Connector',
        description:
            'Create users and groups in CyberFOX Password Manager directly from Azure Active Directory',
    },
    tabs: [
        {
            name: 'general',
            label: 'General',
            component: GeneralTab,
        },
        {
            name: 'auth',
            label: 'Azure Auth',
            component: AuthTab,
        },
        {
            name: 'users_groups',
            label: 'Users & Groups',
            component: UsersGroupsTab,
        },
        {
            name: 'rules',
            label: 'Sync Rules',
            component: RulesTab,
        },
    ],
};
